'use client';

import { useMemo } from 'react';
import { useOthersMapped } from '@liveblocks/react';
import { Avatar } from '@org/design-system';
import { useCollaborationIdentity } from './PresenceProvider';
import { createAvatarFallback, getCollaboratorColor } from './presence';

function CollaborationCursorsInner() {
  const others = useOthersMapped((other) => ({
    connectionId: other.connectionId,
    cursor: other.presence.cursor,
    info: other.info as { name?: string; color?: string } | undefined,
  }));

  const collaborators = useMemo(() => others
    .map(([, value]) => value)
    .filter((item) => item.cursor), [others]);

  if (collaborators.length === 0) {
    return null;
  }

  return (
    <div className="pointer-events-none absolute inset-0 z-40">
      {collaborators.map((collaborator) => {
        const name = collaborator.info?.name ?? `User ${collaborator.connectionId}`;
        const color = collaborator.info?.color ?? getCollaboratorColor(collaborator.connectionId);

        return (
          <div
            key={collaborator.connectionId}
            className="absolute"
            style={{ left: collaborator.cursor!.x, top: collaborator.cursor!.y }}
          >
            <Avatar
              size="sm"
              fallback={createAvatarFallback(name)}
              style={{ outline: `2px solid ${color}`, transform: 'translate(-50%, -50%)' }}
            />
          </div>
        );
      })}
    </div>
  );
}

export function CollaborationCursors() {
  const { enabled } = useCollaborationIdentity();
  if (!enabled) return null;
  return <CollaborationCursorsInner />;
}
